export default "__VITE_ASSET__DiN3Z2O1__"